<template>
    <div>
      <p v-if="$route.params.type && order.fairPayStatus === 'PAID'">Betalt {{ $moment(order.updatedTime).format("DD.M.YYYY HH:mm") }}</p>
      <p v-if="$route.params.type && order.fairPayStatus === 'PARDONED'">Gebyr trukket {{ $moment(order.updatedTime).format("DD.M.YYYY HH:mm") }}</p>
      <div class="d-flex align-center justify-space-between pb-2">
        <p class="profile__container--content__orderhistory--details-price__title mb-0">
          {{ order.siteName }}
        </p>
      </div>
      <div class="d-flex align-center justify-space-between pb-5">
          <div class="profile__container--content__orderhistory--details">
              <p :class="order.fairPayStatus === 'PARDONED' ? 'text-decoration-line-through' : ''" class="font-weight-bold" >Gebyr, {{ formatTitle }}</p>
              <p class="text-decoration-line-through">{{ duration }} min</p>
              <p class="text-decoration-line-through"><b>{{order.treatments ? order.treatments[0].employeeName : order.employeeName}}: </b>{{ $moment(order.appointmentDate).format("dddd DD. MMMM")}}
                  {{fromAndToTime}}
              </p>
          </div>
          <div class="profile__container--content__orderhistory--details-price font-weight-bold">
              <p class="mb-0" :class="order.fairPayStatus === 'PARDONED' ? 'text-decoration-line-through' : ''">
                {{order.actualFee ? order.actualFee.toFixed(2).replace(".", ","): "0,00"}}
              </p>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      order: {
        required: true,
        default: {},
        type: Object,
      },
    },
    computed: {
      duration() {
        if (this.order.totalDurationInMinutes) {
          return this.order.totalDurationInMinutes
        } else {
          let ret = 0;
          if (this.order.treatments) {
            this.order.treatments.forEach(t => {
              ret += Math.round(t.durationInMinutes)
            })
          }
          return ret
        }
      },
      fromAndToTime() {
        if (this.order.fromTime && this.order.toTime) {
          return `, kl ${this.$moment(this.order.fromTime).format("HH:mm")} - ${this.$moment(this.order.toTime).add(1, "seconds").format("HH:mm")}`
        } else if (this.order.startTimeTreatments && this.order.endTimeTreatments) {
          return `, kl ${this.$moment(this.order.startTimeTreatments).format("HH:mm")} - ${this.$moment(this.order.endTimeTreatments).add(1, "seconds").format("HH:mm")}`
        } else {
          return ''
        }
      },
      formatTitle() {
        let ret = ''
        if (this.order.treatmentNames) {
          ret = this.order.treatmentNames
        } else {
          if (this.order.treatments) {
            this.order.treatments.forEach(t => {
              ret += t.treatmentName + ','
            });
          }
        }
        let max = this.$vuetify.breakpoint.mdAndDown ? 30 : 50
        return ret.length > max ? ret.substring(0, max) + '...' : ret
      }
    },
  };
  </script>
  